import { fetchData } from "@/lib/api/fetchData";
import { formatUserPermissions } from "@/lib/formatter/users";

export const getUserPermissionsForTable = async () => {
  try {
    const res = await fetchData("/users/permissions");

    return formatUserPermissions(res.data);
  } catch (error) {
    console.error(error);
    throw new Error("Failed to load user permissions");
  }
};

export const getUserPermissionById = async (id) => {
  try {
    const res = await fetchData(`/users/permissions/${id}`);

    return res.data;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to load user permission");
  }
};

export const getUserPermissionsForSelect = async () => {
  try {
    const res = await fetchData("/users/permissions");

    return res.data.map((affiliate) => ({
      value: affiliate["@id"],
      label: affiliate["name"],
    }));
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch user permissions");
  }
};
